export default __webpack_public_path__ + "static/media/spaces.567ec894.webp";